<template>
  <div class="column-filter units-input">
    <input
      ref="userInput"
      v-bind="$attrs"
      :value="userValue"
      v-on="inputListeners"
    />
    <select
      v-if="true"
      ref="userSelect"
      :value="userUnit"
      v-on="inputListeners"
    >
      <option v-for="unit in units" :value="unit.label">{{
        unit.label
      }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "UnitsInput",
  inheritAttrs: false,
  props: {
    units: Array,
    value: Object | Number
  },
  data() {
    return {
      userValue: 0,
      userUnit: null
    };
  },
  mounted() {
    if (this.units) {
      if (this.value !== null) {
        this.userValue = this.unitsMap[this.value.unit].toUser(
          this.value.value
        );
        this.userUnit = this.value.unit;
      } else {
        this.userValue = 0;
        this.userUnit = this.units[0].label;
      }
    }
  },
  methods: {
    focus() {
      this.$refs.userInput.focus();
    }
  },
  computed: {
    inputListeners() {
      var vm = this;
      return Object.assign({}, this.$listeners, {
        input: function(event) {
          if (vm.units) {
            const unit = vm.$refs.userSelect.value;
            if (unit) {
              const value = vm.unitsMap[unit].fromUser(
                vm.$refs.userInput.value
              );
              vm.$emit("input", { value, unit });
            }
          } else {
            vm.$emit("input", parseInt(event.target.value));
          }
        }
      });
    },
    unitsMap() {
      let m = {};
      for (const unit of this.units) {
        m[unit.label] = unit;
      }
      return m;
    }
  },
  watch: {
    value: function(newValue) {
      if (this.units) {
        this.userValue = this.unitsMap[newValue.unit].toUser(newValue.value);
        this.userUnit = newValue.unit;
      }
    }
  }
};
</script>
<style scoped>
.units-input {
  display: grid;
  grid-template-columns: 4fr 1fr;
  gap: 6px;
  padding: 0;
}

.units-input select {
  border: 1px solid rgb(118, 118, 118);
  border-radius: 2px;
  font-size: 14px;
  background-color: white;
  height: 28px;
}

.units-input input {
  font-size: 14px;
  height: 28px;
  padding-left: 3px;
  padding-right: 2px;
}

.units-input input:focus,
.units-input select:focus {
  outline: rgba(102, 179, 227, 0.75) auto 1px !important;
  outline-offset: 0px;
  z-index: 99;
}
</style>
